import React, { useState, useEffect } from "react";
import AuthServices from "../../services/AuthServices";
import { PDFDocument, rgb, degrees } from "pdf-lib";
import SchoolHeader from "../school/header";
import { useParams } from "react-router-dom";
import { format } from 'date-fns';

const AddWatermark = () => {
  const [pdfSrc, setPdfSrc] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expiredate, setExpiredate] = useState(null);
  const { userid } = useParams();

  console.log(userid, "userid--")
  const pdfUrl = '/Standard Operating Procedures 2025.pdf';
  const addWatermark = async () => {
    setLoading(true);
    setError(null);

    try {
      const existingPdfBytes = await fetch(pdfUrl, {
        headers: { "Ngrok-Skip-Browser-Warning": "true" },
      }).then((res) => res.arrayBuffer());

      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const pages = pdfDoc.getPages();
      const { width, height } = pages[0].getSize();
      const watermarkText = `Expires ${expiredate}`;

      pages.forEach((page) => {
        page.drawText(watermarkText, {
          x: width / 4,
          y: height / 3,
          size: 60,
          color: rgb(0.8, 0.8, 0.8),
          rotate: degrees(45),
          opacity: 0.5,
        });
      });

      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes], { type: "application/pdf" });

      if (pdfSrc) {
        URL.revokeObjectURL(pdfSrc);
      }

      setPdfSrc(URL.createObjectURL(blob));
    } catch (err) {
      console.error("Error adding watermark:", err);
      setError("Failed to process PDF. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (pdfUrl && expiredate) {
      addWatermark();
    }
  }, [pdfUrl, expiredate]);

  useEffect(() => {
    const viewCertificates = async () => {
      try {
        const response = await AuthServices.viewCertificateByUserId({ userid: userid, type: 'Emergency Managment Protocol' });
        const expirationDate = new Date(response.certificatedata.expirationDate);
        const formattedDate = format(expirationDate, "MM dd yyyy");
        setExpiredate(formattedDate);
        console.log(formattedDate, 'get data');

      } catch (error) {
        console.error("Error fetching certificates:", error);
      }
    };

    viewCertificates();
  }, []);

  return (
    <div>
      <div className="main-wrapper">
        <SchoolHeader activeMenu={"Dashboard"} />
        <div className="breadcrumb-bar breadcrumb-bar-info">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-12">
                <div className="breadcrumb-list">
                  <h2 className="breadcrumb-title">Emergency Management Protocol</h2>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          {loading && <p>Processing PDF...</p>}
          {error && <p style={{ color: "red" }}>{error}</p>}

          {pdfSrc && !loading && (
            <>
              <a href={pdfSrc} download="EmergencyManagementProtocol.pdf">
                <button
                  style={{
                    padding: "10px 20px",
                    fontSize: "16px",
                    backgroundColor: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                    width: '200px',
                    float: 'right'
                  }}
                >
                  Download PDF
                </button>
              </a>
              <iframe
                src={pdfSrc}
                width="100%"
                height="650px"
                style={{ border: "1px solid #ccc", marginBottom: "10px" }}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};



export default AddWatermark;
